import palette from 'constants/palette'
import React from 'react'

type Props = {
  className?: string
  strokeColor?: string
}

// Order-stage rail glyph: "order canceled" (Live Updates Overview tab). Geometry is the
// Sketch prototype's own (live-updates-onboarding v40, `bagx`), traced rather
// than approximated so it reads as one set with OrderConfirmed.
const OrderCanceled = ({ className, strokeColor = palette.grey90 }: Props) => (
  <svg
    className={className}
    width="26"
    height="26"
    viewBox="0 0 24 24"
    fill="none"
    stroke={strokeColor}
    strokeWidth="1.9"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="9" />
    <path d="m15 9-6 6" />
    <path d="m9 9 6 6" />
  </svg>
)

export default OrderCanceled
